__turbopack_context__.v({
  "certificate": "certificates-module-scss-module__xAeFNG__certificate",
  "certificatesContainer": "certificates-module-scss-module__xAeFNG__certificatesContainer",
});
